import { PlaylistItemDTO } from '../playlist-item-models/playlist-item-dto.model';

export class AddPlaylistItemsTab {
    playlistItems: PlaylistItemDTO[];
    isAddAnother: boolean;

    constructor(playlistItems: PlaylistItemDTO[], isAddAnother: boolean) {
        this.playlistItems = playlistItems;
        this.isAddAnother = isAddAnother;
    }
}
